import { render, staticRenderFns } from "./AssignationItem.vue?vue&type=template&id=c09f3b40&scoped=true&"
import script from "./AssignationItem.vue?vue&type=script&lang=js&"
export * from "./AssignationItem.vue?vue&type=script&lang=js&"
import style0 from "./AssignationItem.vue?vue&type=style&index=0&id=c09f3b40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c09f3b40",
  null
  
)

export default component.exports